// extracted by mini-css-extract-plugin
var _1 = "DayIntro-moduleDayIntro__vehID";
export { _1 as "DayIntro" }
